import { useState } from 'react'
import { EditButton } from '../EditButton'
import { ClientAssetsPopup } from '../Popups/ClientAssetsPopup'
import { useUpdateClientMutation } from 'src/redux/Api/clientsApi'
import { IClient, IClientCreate } from 'src/utils/Interfaces/client.interface'

export const EditClientAssets = ({ data }: { data: IClient }) => {
  const [isEdit, setIsEdit] = useState(false)
  const { id, ...restData } = data;
  const [updateClient] = useUpdateClientMutation()

  const handleClientMainInfo = async (value: Partial<IClientCreate>) => {
    try {
      await updateClient({ id: data.id.toString(), body: {...restData, ...value} })
      setIsEdit(false)
    } catch (error) {
      console.log(error)
    }
  }

  return (
    <>
      <EditButton onClick={() => setIsEdit(true)} />
      {isEdit && <ClientAssetsPopup defaultData={data} handleClientAssets={handleClientMainInfo} setClientAssetsPopup={() => setIsEdit(false)} />}
    </>
  )
}
